import Picture from 'next/image';

export default function Image({ eager, ...rest }) {
  return (
    <Picture
      loading={eager ? 'eager' : 'lazy'}
      placeholder={eager ? 'blur' : 'empty'}
      blurDataURL={
        eager
          ? 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=='
          : null
      }
      {...rest}
    />
  );
}
